export const EsIcon = ({ width = '20', height = '20' }: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_33327_6225)">
				<path
					d="M-5.29942 20H24.6004C24.8953 20 25.1344 19.7643 25.1344 19.4737V0.526339C25.1344 0.235684 24.8953 0 24.6004 0H-5.29942C-5.59428 5.96216e-05 -5.83337 0.235684 -5.83337 0.526339V19.4737C-5.83337 19.7644 -5.59428 20 -5.29942 20Z"
					fill="#C8414B"
				/>
				<path d="M25.1343 4.21094H-5.83337V15.79H25.1343V4.21094Z" fill="#FFD250" />
				<path
					d="M7.24769 9.99933L7.70041 7.99121C7.74214 7.80627 7.59934 7.63086 7.40712 7.63086H7.08826C6.8961 7.63086 6.75336 7.80627 6.79497 7.99121L7.24769 9.99933Z"
					fill="#C8414B"
				/>
				<path d="M7.78183 8.94727H6.71399V13.4207H7.78183V8.94727Z" fill="#F5F5F5" />
				<path d="M8.04832 8.42188H6.44653V8.94822H8.04832V8.42188Z" fill="#FAB446" />
				<path d="M8.04915 10H5.37939V10.5263H8.04915V10Z" fill="#C8414B" />
				<path d="M8.04881 12.1054L6.44702 11.5791V11.0527L8.04881 11.5791V12.1054Z" fill="#C8414B" />
				<path
					d="M1.1078 8.41992C0.812945 8.41992 0.573853 8.65561 0.573853 8.94626V12.3673C0.573853 13.0067 1.1793 14.2094 3.24348 14.2094C5.30767 14.2094 5.91312 13.0068 5.91312 12.3673V8.94626C5.91312 8.65561 5.67403 8.41992 5.37917 8.41992H1.1078Z"
					fill="#F5F5F5"
				/>
				<path
					d="M3.24348 11.0515H0.573853V8.94626C0.573853 8.65561 0.812945 8.41992 1.1078 8.41992H3.24348V11.0515Z"
					fill="#C8414B"
				/>
				<path
					d="M3.24353 11.0508H5.91316V12.3666C5.91316 13.0933 5.31558 13.6824 4.57835 13.6824C3.84111 13.6824 3.24353 13.0933 3.24353 12.3666V11.0508Z"
					fill="#C8414B"
				/>
				<path
					d="M0.573853 11.0527H3.24348V12.3685C3.24348 13.0953 2.64591 13.6843 1.90867 13.6843C1.17143 13.6843 0.573853 13.0953 0.573853 12.3685V11.0527Z"
					fill="#FAB446"
				/>
				<path
					d="M2.70924 13.4152V11.0527H2.17529V13.6578C2.37392 13.6181 2.55338 13.5314 2.70924 13.4152Z"
					fill="#C8414B"
				/>
				<path
					d="M1.64149 13.6578V11.0527H1.10754V13.4152C1.26347 13.5314 1.44293 13.6181 1.64149 13.6578Z"
					fill="#C8414B"
				/>
				<path d="M2.70945 10H1.10767V10.5263H2.70945V10Z" fill="#FFB441" />
				<path d="M2.70945 8.94727H1.10767V9.4736H2.70945V8.94727Z" fill="#FAB446" />
				<path d="M2.44235 9.25977H1.37451V10.2132H2.44235V9.25977Z" fill="#FAB446" />
				<path d="M0.0396571 13.1582H-1.56213V13.6845H0.0396571V13.1582Z" fill="#FAB446" />
				<path d="M0.0396571 8.42188H-1.56213V8.94822H0.0396571V8.42188Z" fill="#FAB446" />
				<path d="M0.306946 13.6836H-1.82874V14.2099H0.306946V13.6836Z" fill="#5064AA" />
				<path d="M8.31578 13.1582H6.71399V13.6845H8.31578V13.1582Z" fill="#FAB446" />
				<path d="M8.31549 13.6836H6.17981V14.2099H8.31549V13.6836Z" fill="#5064AA" />
				<path d="M4.84531 7.89453H1.64172V8.42087H4.84531V7.89453Z" fill="#FAB446" />
				<path d="M3.51076 6.31641H2.97681V7.89536H3.51076V6.31641Z" fill="#FFB441" />
				<path
					d="M2.70943 7.10624C2.26778 7.10624 1.90857 6.75209 1.90857 6.31679C1.90857 5.88144 2.26784 5.52734 2.70943 5.52734C3.15109 5.52734 3.5103 5.8815 3.5103 6.31679C3.51036 6.75209 3.15109 7.10624 2.70943 7.10624ZM2.70943 6.05362C2.56216 6.05362 2.44246 6.17155 2.44246 6.31679C2.44246 6.46197 2.5621 6.57996 2.70943 6.57996C2.85677 6.57996 2.97641 6.46203 2.97641 6.31679C2.97641 6.17161 2.85677 6.05362 2.70943 6.05362Z"
					fill="#F5F5F5"
				/>
				<path
					d="M3.77731 7.10624C3.33565 7.10624 2.97644 6.75209 2.97644 6.31679C2.97644 5.88144 3.33571 5.52734 3.77731 5.52734C4.21896 5.52734 4.57817 5.8815 4.57817 6.31679C4.57817 6.75209 4.2189 7.10624 3.77731 7.10624ZM3.77731 6.05362C3.63003 6.05362 3.51033 6.17155 3.51033 6.31679C3.51033 6.46197 3.62997 6.57996 3.77731 6.57996C3.92458 6.57996 4.04428 6.46203 4.04428 6.31679C4.04422 6.17161 3.92458 6.05362 3.77731 6.05362Z"
					fill="#F5F5F5"
				/>
				<path
					d="M4.84505 7.63163C4.4034 7.63163 4.04419 7.27748 4.04419 6.84218C4.04419 6.40683 4.40346 6.05273 4.84505 6.05273C5.28671 6.05273 5.64592 6.40689 5.64592 6.84218C5.64592 7.27748 5.28665 7.63163 4.84505 7.63163ZM4.84505 6.57901C4.69778 6.57901 4.57808 6.69695 4.57808 6.84218C4.57808 6.98736 4.69772 7.10535 4.84505 7.10535C4.99233 7.10535 5.11203 6.98742 5.11203 6.84218C5.11203 6.69695 4.99233 6.57901 4.84505 6.57901Z"
					fill="#F5F5F5"
				/>
				<path
					d="M1.64156 7.63163C1.19991 7.63163 0.840698 7.27748 0.840698 6.84218C0.840698 6.40683 1.19997 6.05273 1.64156 6.05273C2.08321 6.05273 2.44243 6.40689 2.44243 6.84218C2.44249 7.27748 2.08321 7.63163 1.64156 7.63163ZM1.64156 6.57901C1.49429 6.57901 1.37459 6.69695 1.37459 6.84218C1.37459 6.98736 1.49422 7.10535 1.64156 7.10535C1.7889 7.10535 1.90854 6.98736 1.90854 6.84212C1.90854 6.69695 1.7889 6.57901 1.64156 6.57901Z"
					fill="#F5F5F5"
				/>
				<path
					d="M4.84512 12.1044V12.3676C4.84512 12.5127 4.72537 12.6307 4.57815 12.6307C4.43093 12.6307 4.31117 12.5127 4.31117 12.3676V12.1044H4.84512ZM5.37901 11.5781H3.77722V12.3676C3.77722 12.8029 4.1365 13.157 4.57809 13.157C5.01974 13.157 5.37895 12.8029 5.37895 12.3676V11.5781H5.37901Z"
					fill="#FAB446"
				/>
				<path
					d="M4.57814 10.5263C4.28328 10.5263 4.04419 10.2906 4.04419 9.99994V9.4736C4.04419 9.18295 4.28328 8.94727 4.57814 8.94727C4.873 8.94727 5.11209 9.18295 5.11209 9.4736V9.99994C5.11209 10.2906 4.873 10.5263 4.57814 10.5263Z"
					fill="#FFA0D2"
				/>
				<path
					d="M3.24325 11.8406C3.68555 11.8406 4.04411 11.4872 4.04411 11.0512C4.04411 10.6152 3.68555 10.2617 3.24325 10.2617C2.80094 10.2617 2.44238 10.6152 2.44238 11.0512C2.44238 11.4872 2.80094 11.8406 3.24325 11.8406Z"
					fill="#5064AA"
				/>
				<path d="M3.51076 5.26367H2.97681V6.84263H3.51076V5.26367Z" fill="#FAB446" />
				<path
					d="M1.6415 7.89536L1.10754 7.36903L1.42031 7.06072C1.90375 6.58417 2.55952 6.31641 3.24329 6.31641C3.92706 6.31641 4.58277 6.58417 5.06628 7.06072L5.37904 7.36903L4.84509 7.89536H1.6415Z"
					fill="#C8414B"
				/>
				<path
					d="M3.24342 7.63181C3.39086 7.63181 3.51039 7.51398 3.51039 7.36864C3.51039 7.22329 3.39086 7.10547 3.24342 7.10547C3.09597 7.10547 2.97644 7.22329 2.97644 7.36864C2.97644 7.51398 3.09597 7.63181 3.24342 7.63181Z"
					fill="#FFD250"
				/>
				<path
					d="M2.17518 7.63181C2.32262 7.63181 2.44215 7.51398 2.44215 7.36864C2.44215 7.22329 2.32262 7.10547 2.17518 7.10547C2.02773 7.10547 1.9082 7.22329 1.9082 7.36864C1.9082 7.51398 2.02773 7.63181 2.17518 7.63181Z"
					fill="#FFD250"
				/>
				<path
					d="M4.3108 7.63181C4.45825 7.63181 4.57777 7.51398 4.57777 7.36864C4.57777 7.22329 4.45825 7.10547 4.3108 7.10547C4.16335 7.10547 4.04382 7.22329 4.04382 7.36864C4.04382 7.51398 4.16335 7.63181 4.3108 7.63181Z"
					fill="#FFD250"
				/>
				<path d="M1.10762 10H-1.56213V10.5263H1.10762V10Z" fill="#C8414B" />
				<path d="M-1.56201 12.1054L0.0397191 11.5791V11.0527L-1.56201 11.5791V12.1054Z" fill="#C8414B" />
			</g>
			<defs>
				<clipPath id="clip0_33327_6225">
					<rect width="20" height="20" rx="10" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
